import { render, staticRenderFns } from "./DimensionsHeader.vue?vue&type=template&id=680b273b"
import script from "./DimensionsHeader.vue?vue&type=script&lang=js"
export * from "./DimensionsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports